import { Center, Loader, useMantineTheme } from "@mantine/core";
import { SvgOvalLoader } from "./SvgOvalLoader";

// O oval de sempre, em SVG para contar como conteúdo no FCP (ver SvgOvalLoader).
const loaders = { ...Loader.defaultLoaders, svgOval: SvgOvalLoader };

const Loading: React.FC = () => {
  const theme = useMantineTheme();

  return (
    <Center
      style={{
        height: "100vh",
        backgroundColor: theme.colors["background_3"][0],
      }}>
      <Loader
        loaders={loaders}
        type="svgOval"
        size="xl"
        color={theme.colors["contrast_text"][0]}
      />
    </Center>
  );
};

export default Loading;
